import type { KpiPeriodBound } from '@klareospace/pharos-lib-types';
import { KPI_GRANULARITY, KPI_KEYS } from '@klareospace/pharos-lib-types';

import { kpiKeys } from '../api';
import type { OrderKpisTodayScope } from './use-order-kpis-today';
import { useKpiRealtimeSync } from './use-kpi-realtime-sync';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface UseDriverKpisTodayRealtimeSyncParams {
  bound: Required<KpiPeriodBound>;
  enabled: boolean;
  scope: OrderKpisTodayScope;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

/**
 * Keeps the cached today's `driver-task-kpis` KPI in sync with realtime `kpis:updated`
 * notifications. Does NOT signal page presence — `useOrderKpisTodayRealtimeSync` already signals
 * presence on the "home" page once per page mount.
 */
export function useDriverKpisTodayRealtimeSync({ bound, enabled, scope }: UseDriverKpisTodayRealtimeSyncParams): void {
  useKpiRealtimeSync({
    bound,
    enabled,
    granularity: KPI_GRANULARITY.DAY,
    kpiKey: KPI_KEYS.DRIVER_TASK_KPIS,
    queryKey: kpiKeys.driverDay({ ...bound, ...scope }),
    scope,
    signalPresence: false,
  });
}
